import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './styles.module.css';
import SidePanelController from '../controllers/SidePanelController';
import classNames from 'classnames';

const SidePanelHeader: React.FC = () => {
  const controller = useController(SidePanelController);
  const { slideDepth } = controller.state;
  return (
    <div>
      <div
        className={classNames(styles.sidePanelHeaderBack, {
          [styles.sidePanelHeaderBackHidden]: slideDepth === 1,
        })}
      >
        {controller.backButtonVisible && (
          <aha-button
            class='p-0'
            kind='plain'
            onClick={() => {
              controller.actionMenuBack();
            }}
          >
            <i className='fa-solid fa-arrow-left mr-1' />
            <span>{controller.backButtonLabel}</span>
          </aha-button>
        )}
      </div>
    </div>
  );
};

export default ApplicationView(SidePanelHeader);
